/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon20Light = forwardRef('ArrowCollapseCHOpenIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.707 11.414a2 2 0 0 1 0-2.828l4.44-4.44a.5.5 0 1 1 .706.708L3.414 9.293a1 1 0 0 0 0 1.414l4.44 4.44a.5.5 0 0 1-.708.707l-4.44-4.44Z" }),
        React.createElement("path", { d: "M17.293 11.414a2 2 0 0 0 0-2.828l-4.44-4.44a.5.5 0 1 0-.707.708l4.44 4.439a1 1 0 0 1 0 1.414l-4.44 4.44a.5.5 0 0 0 .707.707l4.44-4.44Z" })));
});
